import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import { SERVICE_NAME } from "@zapier/utils";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { ManagedConnectionSource } from "./managedConnectionSource";

export function useEmitManagedConnectionCreatedEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (source: ManagedConnectionSource, { isShared }: { isShared: boolean }) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ManagedConnectionCreated,
        optionSelected: source,
        // custom_tracking_fields values must be string | null (Avro schema).
        customTrackingFields: { isShared: String(isShared) },
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
